'use strict';

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var errCode = require('err-code');

var debug = require('debug');

var first = require('it-first');

var block = require('multiformats/block');

var cborg = require('cborg');

var dagPb = require('@ipld/dag-pb');

var blockstore = require('./utils/blockstore.js');

var walkDag = require('./utils/walk-dag.js');

var pinTypes = require('./pin-types.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var first__default = /*#__PURE__*/_interopDefaultLegacy(first);

var cborg__namespace = /*#__PURE__*/_interopNamespace(cborg);

var dagPb__namespace = /*#__PURE__*/_interopNamespace(dagPb);

function invalidPinTypeErr(type) {
  var errMsg = "Invalid type '".concat(type, "', must be one of {direct, indirect, recursive, all}");
  return errCode__default["default"](new Error(errMsg), 'ERR_INVALID_PIN_TYPE');
}

var PinManager = /*#__PURE__*/function () {
  function PinManager(_ref) {
    var pinstore = _ref.pinstore,
        blockstore = _ref.blockstore,
        loadCodec = _ref.loadCodec;

    _classCallCheck(this, PinManager);

    this.pinstore = pinstore;
    this.blockstore = blockstore;
    this.loadCodec = loadCodec;
    this.log = debug__default["default"]('ipfs:repo:pin');
    this.directPins = new Set();
    this.recursivePins = new Set();
  }

  _createClass(PinManager, [{
    key: "pinDirectly",
    value: function () {
      var _pinDirectly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
        var options,
            pin,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return this.blockstore.get(cid, options);

              case 3:
                pin = {
                  depth: 0
                };

                if (cid.version !== 0) {
                  pin.version = cid.version;
                }

                if (cid.code !== dagPb__namespace.code) {
                  pin.codec = cid.code;
                }

                if (options.metadata) {
                  pin.metadata = options.metadata;
                }

                return _context.abrupt("return", this.pinstore.put(blockstore.cidToKey(cid), cborg__namespace.encode(pin)));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function pinDirectly(_x3) {
        return _pinDirectly.apply(this, arguments);
      }

      return pinDirectly;
    }()
  }, {
    key: "unpin",
    value: function unpin(cid, options) {
      return this.pinstore.delete(blockstore.cidToKey(cid), options);
    }
  }, {
    key: "pinRecursively",
    value: function () {
      var _pinRecursively = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid) {
        var options,
            pin,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                _context2.next = 3;
                return this.fetchCompleteDag(cid, options);

              case 3:
                pin = {
                  depth: Infinity
                };

                if (cid.version !== 0) {
                  pin.version = cid.version;
                }

                if (cid.code !== dagPb__namespace.code) {
                  pin.codec = cid.code;
                }

                if (options.metadata) {
                  pin.metadata = options.metadata;
                }

                _context2.next = 9;
                return this.pinstore.put(blockstore.cidToKey(cid), cborg__namespace.encode(pin));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function pinRecursively(_x4) {
        return _pinRecursively.apply(this, arguments);
      }

      return pinRecursively;
    }()
  }, {
    key: "directKeys",
    value: function directKeys(options) {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, pin, version, codec, multihash;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context3.prev = 2;
                _iterator = _asyncIterator(_this.pinstore.query({
                  filters: [function (entry) {
                    var pin = cborg__namespace.decode(entry.value);
                    return pin.depth === 0;
                  }]
                }));

              case 4:
                _context3.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                  _context3.next = 17;
                  break;
                }

                entry = _step.value;
                pin = cborg__namespace.decode(entry.value);
                version = pin.version || 0;
                codec = pin.codec != null ? pin.codec : dagPb__namespace.code;
                multihash = blockstore.keyToMultihash(entry.key);
                _context3.next = 14;
                return {
                  cid: cid.CID.create(version, codec, multihash),
                  metadata: pin.metadata
                };

              case 14:
                _iteratorAbruptCompletion = false;
                _context3.next = 4;
                break;

              case 17:
                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 23:
                _context3.prev = 23;
                _context3.prev = 24;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context3.next = 28;
                  break;
                }

                _context3.next = 28;
                return _awaitAsyncGenerator(_iterator.return());

              case 28:
                _context3.prev = 28;

                if (!_didIteratorError) {
                  _context3.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context3.finish(28);

              case 32:
                return _context3.finish(23);

              case 33:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 19, 23, 33], [24,, 28, 32]]);
      }))();
    }
  }, {
    key: "recursiveKeys",
    value: function recursiveKeys(options) {
      var _this2 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, entry, pin, version, codec, multihash;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context4.prev = 2;
                _iterator2 = _asyncIterator(_this2.pinstore.query({
                  filters: [function (entry) {
                    var pin = cborg__namespace.decode(entry.value);
                    return pin.depth === Infinity;
                  }]
                }));

              case 4:
                _context4.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context4.sent).done)) {
                  _context4.next = 17;
                  break;
                }

                entry = _step2.value;
                pin = cborg__namespace.decode(entry.value);
                version = pin.version || 0;
                codec = pin.codec != null ? pin.codec : dagPb__namespace.code;
                multihash = blockstore.keyToMultihash(entry.key);
                _context4.next = 14;
                return {
                  cid: cid.CID.create(version, codec, multihash),
                  metadata: pin.metadata
                };

              case 14:
                _iteratorAbruptCompletion2 = false;
                _context4.next = 4;
                break;

              case 17:
                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 23:
                _context4.prev = 23;
                _context4.prev = 24;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 28;
                return _awaitAsyncGenerator(_iterator2.return());

              case 28:
                _context4.prev = 28;

                if (!_didIteratorError2) {
                  _context4.next = 31;
                  break;
                }

                throw _iteratorError2;

              case 31:
                return _context4.finish(28);

              case 32:
                return _context4.finish(23);

              case 33:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 19, 23, 33], [24,, 28, 32]]);
      }))();
    }
  }, {
    key: "indirectKeys",
    value: function indirectKeys(options) {
      var _this3 = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _cid, _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, childCid, types, result;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _iteratorAbruptCompletion3 = false;
                _didIteratorError3 = false;
                _context5.prev = 2;
                _iterator3 = _asyncIterator(_this3.recursiveKeys());

              case 4:
                _context5.next = 6;
                return _awaitAsyncGenerator(_iterator3.next());

              case 6:
                if (!(_iteratorAbruptCompletion3 = !(_step3 = _context5.sent).done)) {
                  _context5.next = 46;
                  break;
                }

                _cid = _step3.value.cid;
                _iteratorAbruptCompletion4 = false;
                _didIteratorError4 = false;
                _context5.prev = 10;
                _iterator4 = _asyncIterator(walkDag.walkDag(_cid, _this3.blockstore, _this3.loadCodec, options));

              case 12:
                _context5.next = 14;
                return _awaitAsyncGenerator(_iterator4.next());

              case 14:
                if (!(_iteratorAbruptCompletion4 = !(_step4 = _context5.sent).done)) {
                  _context5.next = 27;
                  break;
                }

                childCid = _step4.value;
                types = [pinTypes.PinTypes.recursive];
                _context5.next = 19;
                return _awaitAsyncGenerator(_this3.isPinnedWithType(childCid, types));

              case 19:
                result = _context5.sent;

                if (!result.pinned) {
                  _context5.next = 22;
                  break;
                }

                return _context5.abrupt("continue", 24);

              case 22:
                _context5.next = 24;
                return childCid;

              case 24:
                _iteratorAbruptCompletion4 = false;
                _context5.next = 12;
                break;

              case 27:
                _context5.next = 33;
                break;

              case 29:
                _context5.prev = 29;
                _context5.t0 = _context5["catch"](10);
                _didIteratorError4 = true;
                _iteratorError4 = _context5.t0;

              case 33:
                _context5.prev = 33;
                _context5.prev = 34;

                if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
                  _context5.next = 38;
                  break;
                }

                _context5.next = 38;
                return _awaitAsyncGenerator(_iterator4.return());

              case 38:
                _context5.prev = 38;

                if (!_didIteratorError4) {
                  _context5.next = 41;
                  break;
                }

                throw _iteratorError4;

              case 41:
                return _context5.finish(38);

              case 42:
                return _context5.finish(33);

              case 43:
                _iteratorAbruptCompletion3 = false;
                _context5.next = 4;
                break;

              case 46:
                _context5.next = 52;
                break;

              case 48:
                _context5.prev = 48;
                _context5.t1 = _context5["catch"](2);
                _didIteratorError3 = true;
                _iteratorError3 = _context5.t1;

              case 52:
                _context5.prev = 52;
                _context5.prev = 53;

                if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                  _context5.next = 57;
                  break;
                }

                _context5.next = 57;
                return _awaitAsyncGenerator(_iterator3.return());

              case 57:
                _context5.prev = 57;

                if (!_didIteratorError3) {
                  _context5.next = 60;
                  break;
                }

                throw _iteratorError3;

              case 60:
                return _context5.finish(57);

              case 61:
                return _context5.finish(52);

              case 62:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 48, 52, 62], [10, 29, 33, 43], [34,, 38, 42], [53,, 57, 61]]);
      }))();
    }
  }, {
    key: "isPinnedWithType",
    value: function () {
      var _isPinnedWithType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(cid, types, options) {
        var all, direct, recursive, indirect, result, pin, self, findChild, _findChild, parentCid;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _findChild = function _findChild3() {
                  _findChild = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key, source) {
                    var _iteratorAbruptCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, parentCid, _iteratorAbruptCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, childCid;

                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _iteratorAbruptCompletion5 = false;
                            _didIteratorError5 = false;
                            _context6.prev = 2;
                            _iterator5 = _asyncIterator(source);

                          case 4:
                            _context6.next = 6;
                            return _awaitAsyncGenerator(_iterator5.next());

                          case 6:
                            if (!(_iteratorAbruptCompletion5 = !(_step5 = _context6.sent).done)) {
                              _context6.next = 42;
                              break;
                            }

                            parentCid = _step5.value.cid;
                            _iteratorAbruptCompletion6 = false;
                            _didIteratorError6 = false;
                            _context6.prev = 10;
                            _iterator6 = _asyncIterator(walkDag.walkDag(parentCid, self.blockstore, self.loadCodec));

                          case 12:
                            _context6.next = 14;
                            return _awaitAsyncGenerator(_iterator6.next());

                          case 14:
                            if (!(_iteratorAbruptCompletion6 = !(_step6 = _context6.sent).done)) {
                              _context6.next = 23;
                              break;
                            }

                            childCid = _step6.value;

                            if (!childCid.equals(key)) {
                              _context6.next = 20;
                              break;
                            }

                            _context6.next = 19;
                            return parentCid;

                          case 19:
                            return _context6.abrupt("return");

                          case 20:
                            _iteratorAbruptCompletion6 = false;
                            _context6.next = 12;
                            break;

                          case 23:
                            _context6.next = 29;
                            break;

                          case 25:
                            _context6.prev = 25;
                            _context6.t0 = _context6["catch"](10);
                            _didIteratorError6 = true;
                            _iteratorError6 = _context6.t0;

                          case 29:
                            _context6.prev = 29;
                            _context6.prev = 30;

                            if (!(_iteratorAbruptCompletion6 && _iterator6.return != null)) {
                              _context6.next = 34;
                              break;
                            }

                            _context6.next = 34;
                            return _awaitAsyncGenerator(_iterator6.return());

                          case 34:
                            _context6.prev = 34;

                            if (!_didIteratorError6) {
                              _context6.next = 37;
                              break;
                            }

                            throw _iteratorError6;

                          case 37:
                            return _context6.finish(34);

                          case 38:
                            return _context6.finish(29);

                          case 39:
                            _iteratorAbruptCompletion5 = false;
                            _context6.next = 4;
                            break;

                          case 42:
                            _context6.next = 48;
                            break;

                          case 44:
                            _context6.prev = 44;
                            _context6.t1 = _context6["catch"](2);
                            _didIteratorError5 = true;
                            _iteratorError5 = _context6.t1;

                          case 48:
                            _context6.prev = 48;
                            _context6.prev = 49;

                            if (!(_iteratorAbruptCompletion5 && _iterator5.return != null)) {
                              _context6.next = 53;
                              break;
                            }

                            _context6.next = 53;
                            return _awaitAsyncGenerator(_iterator5.return());

                          case 53:
                            _context6.prev = 53;

                            if (!_didIteratorError5) {
                              _context6.next = 56;
                              break;
                            }

                            throw _iteratorError5;

                          case 56:
                            return _context6.finish(53);

                          case 57:
                            return _context6.finish(48);

                          case 58:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, null, [[2, 44, 48, 58], [10, 25, 29, 39], [30,, 34, 38], [49,, 53, 57]]);
                  }));
                  return _findChild.apply(this, arguments);
                };

                findChild = function _findChild2(_x, _x2) {
                  return _findChild.apply(this, arguments);
                };

                if (!Array.isArray(types)) {
                  types = [types];
                }

                all = types.includes(pinTypes.PinTypes.all);
                direct = types.includes(pinTypes.PinTypes.direct);
                recursive = types.includes(pinTypes.PinTypes.recursive);
                indirect = types.includes(pinTypes.PinTypes.indirect);

                if (!(recursive || direct || all)) {
                  _context7.next = 14;
                  break;
                }

                _context7.next = 10;
                return first__default["default"](this.pinstore.query({
                  prefix: blockstore.cidToKey(cid).toString(),
                  filters: [function (entry) {
                    if (all) {
                      return true;
                    }

                    var pin = cborg__namespace.decode(entry.value);
                    return types.includes(pin.depth === 0 ? pinTypes.PinTypes.direct : pinTypes.PinTypes.recursive);
                  }],
                  limit: 1
                }));

              case 10:
                result = _context7.sent;

                if (!result) {
                  _context7.next = 14;
                  break;
                }

                pin = cborg__namespace.decode(result.value);
                return _context7.abrupt("return", {
                  cid: cid,
                  pinned: true,
                  reason: pin.depth === 0 ? pinTypes.PinTypes.direct : pinTypes.PinTypes.recursive,
                  metadata: pin.metadata
                });

              case 14:
                self = this;

                if (!(all || indirect)) {
                  _context7.next = 21;
                  break;
                }

                _context7.next = 18;
                return first__default["default"](findChild(cid, this.recursiveKeys()));

              case 18:
                parentCid = _context7.sent;

                if (!parentCid) {
                  _context7.next = 21;
                  break;
                }

                return _context7.abrupt("return", {
                  cid: cid,
                  pinned: true,
                  reason: pinTypes.PinTypes.indirect,
                  parent: parentCid
                });

              case 21:
                return _context7.abrupt("return", {
                  cid: cid,
                  pinned: false
                });

              case 22:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function isPinnedWithType(_x5, _x6, _x7) {
        return _isPinnedWithType.apply(this, arguments);
      }

      return isPinnedWithType;
    }()
  }, {
    key: "fetchCompleteDag",
    value: function () {
      var _fetchCompleteDag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(cid, options) {
        var _this4 = this;

        var seen, walkDag;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                seen = new Set();

                walkDag = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(cid, options) {
                    var bytes, codec, block$1;
                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (!seen.has(cid.toString())) {
                              _context8.next = 2;
                              break;
                            }

                            return _context8.abrupt("return");

                          case 2:
                            seen.add(cid.toString());
                            _context8.next = 5;
                            return _this4.blockstore.get(cid, options);

                          case 5:
                            bytes = _context8.sent;
                            _context8.next = 8;
                            return _this4.loadCodec(cid.code);

                          case 8:
                            codec = _context8.sent;
                            block$1 = block.createUnsafe({
                              bytes: bytes,
                              cid: cid,
                              codec: codec
                            });
                            _context8.next = 12;
                            return Promise.all(_toConsumableArray(block$1.links()).map(function (_ref3) {
                              var _ref4 = _slicedToArray(_ref3, 2),
                                  childCid = _ref4[1];

                              return walkDag(childCid, options);
                            }));

                          case 12:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function walkDag(_x10, _x11) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                _context9.next = 4;
                return walkDag(cid, options);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function fetchCompleteDag(_x8, _x9) {
        return _fetchCompleteDag.apply(this, arguments);
      }

      return fetchCompleteDag;
    }()
  }], [{
    key: "checkPinType",
    value: function checkPinType(type) {
      if (typeof type !== 'string' || !Object.keys(pinTypes.PinTypes).includes(type)) {
        throw invalidPinTypeErr(type);
      }

      return true;
    }
  }]);

  return PinManager;
}();

exports.PinManager = PinManager;